import { create } from "zustand";

type RouteTransitionStore = {
  isTransitioning: boolean;
  target: string | null;
  startedAt: number;
  start: (target: string) => void;
  stop: () => void;
};

export const useRouteTransitionStore = create<RouteTransitionStore>((set) => ({
  isTransitioning: false,
  target: null,
  startedAt: 0,

  start: (target) =>
    set({
      isTransitioning: true,
      target,
      startedAt: Date.now(),
    }),

  stop: () =>
    set({
      isTransitioning: false,
      target: null,
    }),
}));
